<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />

    <v-data-table
      :headers="headers"
      :items="list"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <template>
          <v-btn
            class="float-right mt-3 mr-3"
            color="primary"
            dark
            @click="goNewUser()"
            >New User</v-btn
          >
        </template>
        <v-toolbar flat color="white">
          <v-toolbar-title>Users</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>

        <v-row class="ml-2 mr-2">
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-text-field
              v-model="filter_firstname"
              label="First Name"
              outlined
              dense
              @keyup="searchFilter"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-text-field
              label="Last Name"
              v-model="filter_lastname"
              outlined
              dense
              @keyup="searchFilter"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-text-field
              label="Eamil"
              v-model="filter_email"
              outlined
              dense
              @keyup="searchFilter"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="pt-0 pb-0">
            <v-checkbox
              class="pt-0"
              v-model="filter_admin"
              label="Only Admins"
              color="primary"
              hide-details
              @change="searchFilter"
            ></v-checkbox>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.userid`]="{ item }">
        {{
          list
            .map(function (x) {
              return x.userid;
            })
            .indexOf(item.userid) + 1
        }}
      </template>
      <template v-slot:[`item.firstname`]="{ item }">
        {{ item.firstname + " " + item.lastname }}
      </template>
      <template v-slot:[`item.isadmin`]="{ item }">
        <p v-if="item.isadmin == false">
          <span title="User"
            ><i class="status fas fa-user orange--text"></i
          ></span>
        </p>
        <p v-if="item.isadmin == true">
          <span title="Admin"
            ><i class="status fas fa-user-shield blue--text"></i
          ></span>
        </p>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <p v-if="item.status == false">
          <span><i class="status fa fa-times-circle red--text"></i></span>
        </p>
        <p v-if="item.status == true">
          <span><i class="status fa fa-check-circle green--text"></i></span>
        </p>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          title="Edit"
          small
          class="mr-2"
          color="#1976D2"
          @click.stop="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          title="Delete"
          small
          @click.stop="deleteItem(item)"
          color="#FF5252"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>

    <template>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="PagesNumber"
          :total-visible="7"
          @input="changePage($event)"
        ></v-pagination>
      </div>
    </template>
    <DeleteUser :DeleteDialog="DeleteDialog" :DeleteItem="DeleteItem" 
    v-on:closeDialog="closeDialogMethodClose($event)" 
    v-on:renderData="refreshData($event)"/>
  </v-container>
</template>
<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import DeleteUser from "@/components/User/DeleteUser";


export default {
  data: () => ({
    breadcrumbs: [
      {
        text: "Dashboard",
        disabled: false,
        to: "/",
      },
      {
        text: "Users",
        disabled: true,
      },
    ],
    Ruls: ["Admin", "User"],
    list: [],
    headers: [
      { text: "#", value: "userid" },
      { text: "Full Name", value: "firstname" },
      { text: "Email", value: "email" },
      { text: "Type", value: "isadmin" },
      { text: "Status", value: "status" },
      { text: "Action ", value: "action" },
    ],
    page: 1,
    PagesNumber: 0,
    pageUrl: 1,
    filter_firstname: "",
    filter_lastname: "",
    filter_email: "",
    filter_admin: 0,
    filterStatmint: "",

    DeleteDialog: false  ,
    DeleteItem : {} ,

  }),
  mounted() {
    this.getAllUsers();
    this.filterStatmint =
      "&filter[firstname]=" +
      this.filter_firstname +
      "&filter[lastname]=" +
      this.filter_lastname +
      "&filter[email]=" +
      this.filter_email;
  },
  components: {
    Breadcrumbs,
    DeleteUser
  },
  methods: {
    getAllUsers() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/user?per_page=20&page=" + this.pageUrl + this.filterStatmint
        )
        .then((response) => {
          this.PagesNumber = response["data"]["meta"]["last_page"];
          this.list = response["data"]["data"];
        });
    },
    changePage(val) {
      this.pageUrl = val;
      this.getAllUsers();
    },
    searchFilter() {
      this.pageUrl = 1;
      this.filterStatmint =
        "&filter[firstname]=" +
        this.filter_firstname +
        "&filter[lastname]=" +
        this.filter_lastname +
        "&filter[email]=" +
        this.filter_email +
        "&isadmin=" +
        this.filter_admin;
      this.getAllUsers();
    },
    goNewUser() {
      this.$router.push({ name: "AddUser" }).catch(() => {});
    },
    editItem(item){
      this.$router.push({
        name: "EditUser",
        params: { userID: item.userid },
      });
    } ,
    deleteItem(item){
      this.DeleteDialog = true;
      this.DeleteItem = item
    },
    closeDialogMethodClose() {
      this.DeleteDialog = false;
    },
    refreshData(value) {
      if (value) {
        this.getAllUsers();
      }
    },
  },
};
</script>